export default "__VITE_ASSET__BVyqFaST__"